import { Logo } from "./Header";
import { CONTACT } from "../../config/site";

const LINKS = [
  { label: "The Estate", href: "/#about" },
  { label: "Location", href: "/#location" },
  { label: "Master Plan", href: "/#master-plan" },
  { label: "Pricing", href: "/#pricing" },
  { label: "Incentives", href: "/#incentives" },
  { label: "For Investors", href: "/#investors" },
  { label: "Channel Partners", href: "/#partners" },
  { label: "Blog", href: "/blog" },
  { label: "FAQ", href: "/#faq" },
];

export const Footer = () => (
  <footer className="bg-forest-dark text-paper grain relative" data-testid="footer">
    <div className="relative mx-auto max-w-7xl px-5 py-16 sm:px-8">
      <div className="grid gap-10 md:grid-cols-3">
        <div>
          <Logo light className="h-16" />
          <p className="mt-5 max-w-xs text-sm leading-relaxed text-paper/60">
            Bhiwani Industrial Development Cluster — a Govt. of Haryana approved MSME cluster on
            Bhiwani–Loharu Road, NH-709, by Tirupati Developers.
          </p>
        </div>
        <nav aria-label="Footer">
          <p className="text-xs uppercase tracking-[0.22em] font-medium text-gold">Explore</p>
          <ul className="mt-4 grid grid-cols-2 gap-x-6 gap-y-2.5">
            {LINKS.map((l) => (
              <li key={l.href}>
                <a href={l.href} className="text-sm text-paper/70 hover:text-gold transition-colors duration-150">
                  {l.label}
                </a>
              </li>
            ))}
          </ul>
        </nav>
        <div>
          <p className="text-xs uppercase tracking-[0.22em] font-medium text-gold">Site office</p>
          <p className="mt-4 text-sm leading-relaxed text-paper/70">{CONTACT.address}</p>
          <p className="mt-3 text-sm text-paper/70">
            {CONTACT.phones.slice(0, 2).join(" · ")}
          </p>
          <p className="mt-1 text-sm text-paper/70">{CONTACT.email}</p>
        </div>
      </div>

      <div className="mt-14 border-t border-paper/15 pt-8">
        <p className="text-center font-display text-3xl sm:text-4xl font-medium italic text-gold" data-testid="footer-closing">
          "India is building. Build with us."
        </p>
        <p className="mt-6 text-center text-[11px] leading-relaxed text-paper/40 max-w-3xl mx-auto">
          *All prices, payment plans and incentives mentioned are indicative and subject to change,
          eligibility and approval under applicable policies. Images are illustrative. Please verify
          all details at the site office before booking.
        </p>
        <p className="mt-4 text-center text-xs text-paper/40">
          © {new Date().getFullYear()} Tirupati Developers, Bhiwani. All rights reserved.
        </p>
      </div>
    </div>
  </footer>
);
